export const getMainMenu = (state) => state.menus.main.data;

export const getActiveMenuItemSelector = (state) => state.menus.activeMenuItem;

export const getActiveNavigationMenuItemSelector = (state) =>
  state.menus.activeNavigationMenuItem;

export const isMenuOpened = (state) => state.menus.isOpen;
